import {useEffect, useRef} from "react";
import {cuppa, log} from "../../../cuppa/cuppa";
import {CuppaDrawer} from '../../../cuppa/components/cuppa.drawer';
import {Menu} from "./Menu";
import {Globals} from "../../controllers/Globals";

export function MenuMobile(props){
	const drawer = useRef();

	useEffect(()=>{
		Globals.menuDrawer = drawer?.current;
	}, [drawer])

	return(
		<>
			<cuppa-drawer ref={drawer} position="left" width={260}  >
				<cuppa-drawer-content style={{display:'flex', height:'100%', flexDirection:'column'}}>
					<Menu style={{position:'relative', height:'100%'}} />
				</cuppa-drawer-content>
			</cuppa-drawer>
		</>
	)
}
